import React, { useEffect, useState } from "react";
import { Field, Form, Formik, FormikProps, ErrorMessage } from "formik";
import {  Button, Grid, TextField, Typography } from "@material-ui/core";
import Box from '@mui/material/Box';
import IconButton from "@material-ui/core/IconButton";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControl from "@material-ui/core/FormControl";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import axios from "../../../utils/http";
import {
  CHANGE_PRODUCT,
  SEARCH_PRODUCT,
  SELECT_PRODUCT,
} from "../../../utils/urls";
import * as Yup from "yup";

import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

import "./style.css";
import { useHistory } from "react-router";
import { MoreVert } from "@material-ui/icons";
import Header from "../../../Common/header";
import Loader from "../../../Common/Loader";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    boxRoot: {
      "@media (min-width: 1280px)": {
        height: "100vh",
        padding: "10px",
      },
      [theme.breakpoints.down("xs")]: {
        height: "100vh",
        padding: "10px",
      },
      [theme.breakpoints.between("sm", "md")]: {
        height: "100vh",
        padding: "10px",
      },
    },
    typography: {
      color: "#414141",
      fontSize: "20px",
    },
    formControl: {
      margin: "20px 0px",
    },
    root: {
      padding: "5px 45px",
      borderRadius: "19px",
      backgroundColor: "#DA222C",
      color: "#fff",
      margin: "25px",
    },
  })
);

export default function ProductDetails() {
  const [mop, setMop] = useState("");
  const [sku, setSku] = useState("");
  const [mopRange, setMopRange] = useState({
    max_price: 0,
    min_price: 0,
  });
  const [productField, setProductField] = useState({
    product_type: "",
    brand: "",
    model: "",
  });
  const [error, setError] = useState<string>("");
  const [loader, setLoader] = useState(false);

  const classes = useStyles();
  const history = useHistory();

  const historyState: any = history.location.state;
  const crn = historyState.crn || 0;
  const application_id = historyState.application_id || "";
  // console.log("crn", crn.crn)
  useEffect(() => {
    if (application_id !== "") {
      axios.post(CHANGE_PRODUCT, { cd_application_id: application_id });
    }
  }, []);

  const validate = (values: any) => {
    let errors;
    console.log("values", values);

    if (!values.sku.length) {
      if (
        !values.product_type.length ||
        !values.model.length ||
        !values.brand.length
      ) {
        return (errors = "Required all product fields or SKU");
      }
    }
    if (mopRange.max_price == 0) {
      return (errors = `please search the product first`);
    }
    if (values.mop < mopRange.min_price) {
      return (errors = `minimum mop is ${mopRange.min_price}`);
    } else if (values.mop > mopRange.max_price) {
      return (errors = `maximum mop is ${mopRange.max_price}`);
    } else if (values.mop == 0) {
      return (errors = `mop can't be 0`);
    }

    //  errors.message="required all product fields or sku1";
    return errors;
  };

  const search = () => {
    setError("");
    if (!sku.length) {
      if (
        !productField.product_type.length ||
        !productField.model.length ||
        !productField.brand.length
      ) {
        alert("required all product fields or sku");
        return setError("required all product fields or sku");
      }
    }
    setMopRange({
      max_price: 0,
      min_price: 0,
    });

    setLoader(true);
    axios
      .post(SEARCH_PRODUCT, { ...productField, sku, mop: 0 })
      .then((res) => {
        setError("");
        console.log(res.data);
        let productInfo: any = res.data.results;
        setProductField({
          product_type: productInfo.commodity_type,
          brand: productInfo.brand,
          model: productInfo.model_name,
        });
        setSku(productInfo.sku);
        setMopRange({
          max_price: productInfo.max_price,
          min_price: productInfo.min_price,
        });
        setLoader(false);
      })
      .catch((e) => {
        console.log(e.response.data.errors);
        alert(e.response.data.errors?.detail || e.response.data.errors);
        setError(e.response.data.errors?.detail || e.response.data.errors);
        setLoader(false);
      });
  };

  const handleSubmit = () => {
    let errors = validate({ ...productField, sku: sku, mop: mop });

    if (errors) {
      alert(errors);
      return setError(errors);
    }

    setLoader(true);
    axios
      .post(SELECT_PRODUCT, {
        ...productField,
        sku: sku,
        mop: mop,
        crn_id: crn,
        cd_application_id: application_id,
      })
      .then((res) => {
        setLoader(false);
        setError("");
        console.log(res.data.results);
        history.push("/check-eligibility", {
          application_id: res.data.results,
        });
      })
      .catch((e) => {
        console.log(e.response.data.errors);
        setLoader(false);
        setError(e.response.data.errors);
        alert(e.response.data.errors.detail);
      });
  };

  const intialValues = {
    ...productField,
    sku: sku,
    mop: mop,
  };

  const handleSkuChange = (e: any) => {
    setSku(e.target.value);
    setProductField({
      product_type: "",
      brand: "",
      model: "",
    });
    setError("");
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setProductField({ ...productField, [name]: value });
    setSku("");
    setError("");
  };

  return loader ? (
    <Loader loading={true} />
  ) : (
    <div>
      <div>
        <Header pageName="Product Details" />
      </div>
      <Box component="div" className="newCard" sx={{ mt: 7 }}>
        <Grid container direction="column" justifyContent="center">
          <Grid container justifyContent="center">
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <Box component="div">
                <Box component="div" textAlign="left" alignItems="center">
                  {error ? <h6 className="errorMsg">{error}</h6> : ""}
                </Box>
                <Formik initialValues={intialValues} onSubmit={handleSubmit}>
                  {(props: FormikProps<any>) => (
                    <Form>
                      <Field name="sku">
                        {({
                          field, // { name, value, onChange, onBlur }
                          form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                          meta,
                        }: any) => (
                          <>
                            <Box sx={{ mb: 2 }}>
                              <Box
                                sx={{
                                  mb: 1,
                                  fontSize: 17,
                                  color: "#131313",
                                }}
                              >
                                <span>SKU</span>
                              </Box>
                              <FormControl
                                fullWidth
                                className="mobileNoField"
                                variant="outlined"
                              >
                                {/* {console.log("form=>",meta)} */}
                                <InputLabel htmlFor="outlined-adornment-mobile">
                                  SKU
                                </InputLabel>
                                <OutlinedInput
                                  id="outlined-adornment-mobile"
                                  type="text"
                                  value={sku}
                                  endAdornment={
                                    <InputAdornment position="end">
                                      <IconButton
                                        aria-label="toggle mobile visibility"
                                        edge="end"
                                      >
                                        <CheckCircleIcon />
                                      </IconButton>
                                    </InputAdornment>
                                  }
                                  labelWidth={40}
                                  onChange={handleSkuChange}
                                />
                              </FormControl>
                            </Box>
                          </>
                        )}
                      </Field>

                      <Box component="div" className="horizontalLine">
                        <Box component="span" className="horizontalText">
                          OR
                        </Box>
                      </Box>

                      <Field name="product_type">
                        {({
                          field, // { name, value, onChange, onBlur }
                          form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                          meta,
                        }: any) => (
                          <Box sx={{ mb: 2, mt: 3 }}>
                            <Box
                              sx={{
                                mb: 1,
                                fontSize: 17,
                                color: "#131313",
                              }}
                            >
                              <span>Product Type</span>
                            </Box>
                            <FormControl
                              fullWidth
                              variant="outlined"
                              className="mobileNoField"
                            >
                              <InputLabel htmlFor="outlined-adornment-mobile"></InputLabel>
                              <OutlinedInput
                                id="outlined-adornment-mobile"
                                type="text"
                                name="product_type"
                                value={productField.product_type}
                                endAdornment={
                                  <InputAdornment position="end">
                                    <IconButton
                                      aria-label="toggle mobile visibility"
                                      edge="end"
                                    >
                                      <CheckCircleIcon />
                                    </IconButton>
                                  </InputAdornment>
                                }
                                labelWidth={100}
                                onChange={handleChange}
                              />
                            </FormControl>
                          </Box>
                        )}
                      </Field>
                      <Field name="brand">
                        {({
                          field, // { name, value, onChange, onBlur }
                          form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                          meta,
                        }: any) => (
                          <Box sx={{ mb: 2 }}>
                            <Box sx={{ mb: 1, fontSize: 17, color: "#131313" }}>
                              <span> Brand</span>
                            </Box>
                            <FormControl
                              fullWidth
                              variant="outlined"
                              className="mobileNoField"
                            >
                              <InputLabel htmlFor="outlined-adornment-mobile"></InputLabel>
                              <OutlinedInput
                                id="outlined-adornment-mobile"
                                type="text"
                                name="brand"
                                value={productField.brand}
                                endAdornment={
                                  <InputAdornment position="end">
                                    <IconButton
                                      aria-label="toggle mobile visibility"
                                      edge="end"
                                    >
                                      <CheckCircleIcon />
                                    </IconButton>
                                  </InputAdornment>
                                }
                                labelWidth={50}
                                onChange={handleChange}
                              />
                            </FormControl>
                          </Box>
                        )}
                      </Field>

                      <Field name="model">
                        {({
                          field, // { name, value, onChange, onBlur }
                          form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                          meta,
                        }: any) => (
                          <Box sx={{ mb: 2 }}>
                            <Box sx={{ mb: 1, fontSize: 17, color: "#131313" }}>
                              <span> Model</span>
                            </Box>
                            <FormControl
                              fullWidth
                              variant="outlined"
                              className="mobileNoField"
                            >
                              <InputLabel htmlFor="outlined-adornment-mobile"></InputLabel>
                              <OutlinedInput
                                id="outlined-adornment-mobile"
                                type="text"
                                name="model"
                                value={productField.model}
                                endAdornment={
                                  <InputAdornment position="end">
                                    <IconButton
                                      aria-label="toggle mobile visibility"
                                      edge="end"
                                    >
                                      <CheckCircleIcon />
                                    </IconButton>
                                  </InputAdornment>
                                }
                                labelWidth={50}
                                onChange={handleChange}
                              />
                            </FormControl>
                          </Box>
                        )}
                      </Field>

                      <Box textAlign="center" mt={3}>
                        <Button
                          variant="contained"
                          onClick={() => search()}
                          className="redButton"
                          color="secondary"
                        >
                          Search Product
                        </Button>
                      </Box>

                      <Field name="mop">
                        {({
                          field, // { name, value, onChange, onBlur }
                          form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                          meta,
                        }: any) => (
                          <Box sx={{ mb: 1 }}>
                            <Box
                              component="div"
                              className="horizontalLine"
                            ></Box>
                            <Box sx={{ mb: 1, fontSize: 17, color: "#131313" }}>
                              <span>MOP</span>
                            </Box>
                            <FormControl
                              fullWidth
                              variant="outlined"
                              className="mobileNoField"
                            >
                              {Object.values(errors).length ? (
                                <p
                                  style={{ textAlign: "center", color: "red" }}
                                >
                                  {errors.mop}
                                </p>
                              ) : (
                                ""
                              )}

                              <InputLabel
                                htmlFor="outlined-adornment-mobile"
                                style={{ position: "relative" }}
                              ></InputLabel>

                              <OutlinedInput
                                id="outlined-adornment-mobile"
                                type="number"
                                value={mop}
                                endAdornment={
                                  <InputAdornment position="end">
                                    <IconButton
                                      aria-label="toggle mobile visibility"
                                      edge="end"
                                    >
                                      <CheckCircleIcon />
                                    </IconButton>
                                  </InputAdornment>
                                }
                                labelWidth={40}
                                onChange={(e) => setMop(e.target.value)}
                              />
                            </FormControl>
                          </Box>
                        )}
                      </Field>

                      {mopRange.min_price && mopRange.max_price ? (
                        <div>
                          <span className="mopPriceD">
                            &#8377; {mopRange.min_price} - &#8377;{" "}
                            {mopRange.max_price}
                          </span>
                        </div>
                      ) : (
                        <></>
                      )}

                      <Box textAlign="center" mt={3}>
                        <Button
                          variant="contained"
                          className="redButton"
                          color="secondary"
                          onClick={() => handleSubmit()}
                        >
                          Generate Offer!
                        </Button>
                      </Box>
                    </Form>
                  )}
                </Formik>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
